export const NO_IMAGE_SOURCE = 'https://storage.googleapis.com/mindseed_files/lxp/no_image_placeholder.webp'
